module.exports = __webpack_public_path__ + "img/4-materialize.f4f276c2.png";